import React from 'react';
import PropTypes from 'prop-types'

export default function CheckmarkOutline({stroke})
{
	return (
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 104 99" xmlSpace="preserve" stroke={stroke} strokeWidth={5}>
			<path id="Page-1_9_" d="M84.8,24.1L40.5,68.4L19.2,47.1L16,50.3l24.5,24.5L88,27.4L84.8,24.1z" />
		</svg>
	)
}

CheckmarkOutline.propTypes = {
  stroke: PropTypes.string
};